<template>
    <el-button type="primary"  icon="el-icon-search" v-on:click="clickEvent()">查询</el-button>
</template>
  
  <script>
  
  export default {
    name: 'form-query-button',
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// FormQueryButton.vue?a3b87a92